/* EG Collections — Compare (tray, modal, matching, search, reorder, diff toggle) */

(function () {
  var STORAGE_KEY = "eg_collection_compare_v1";

  function egCompareSafeParse(json, fallback) {
    try {
      var out = JSON.parse(json);
      return out && typeof out === "object" ? out : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function egCompareGetRoot() {
    return document.getElementById("eg-collection-filters");
  }

  function egCompareGetSessionId() {
  var key = "eg_compare_session_id";
  var id = "";

  try {
    id = window.sessionStorage ? sessionStorage.getItem(key) : "";
  } catch (e) {}

  if (!id) {
    id = "egc_" + Date.now() + "_" + Math.random().toString(36).slice(2, 10);

    try {
      if (window.sessionStorage) sessionStorage.setItem(key, id);
    } catch (e2) {}
  }

  return id;
}

function egCompareTrackEvent(payload) {
  try {
    if (!payload || typeof payload !== "object") return;

    fetch("https://gear-db-proxy.onrender.com/compare-events", {
      method: "POST",
      credentials: "omit",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    }).catch(function () {});
  } catch (e) {}
}

function egCompareTrackOpen(root, products, typeKey) {
  root = root || egCompareGetRoot();
  products = products || [];

  if (!root || products.length < 2) return;

  var collectionHandle = egCompareGetCollectionHandle(root);
  var productType = typeKey || "";
  var sessionId = egCompareGetSessionId();

  egCompareTrackEvent({
    source: "collection_compare",
    event_type: "compare_open",
    product_a_id: products[0] && products[0].handle ? String(products[0].handle) : null,
    product_b_id: products[1] && products[1].handle ? String(products[1].handle) : null,
    product_type: productType || collectionHandle || null,
    session_id: sessionId
  });

  for (var i = 0; i < products.length; i++) {
    for (var j = i + 1; j < products.length; j++) {
      if (!products[i] || !products[j] || !products[i].handle || !products[j].handle) continue;

      egCompareTrackEvent({
        source: "collection_compare",
        event_type: "compare_pair",
        product_a_id: String(products[i].handle),
        product_b_id: String(products[j].handle),
        product_type: productType || collectionHandle || null,
        session_id: sessionId
      });
    }
  }
}

  function egCompareGetCollectionHandle(root) {
    root = root || egCompareGetRoot();
    if (!root || !root.dataset) return "";
    return String(root.dataset.egCollection || "").trim();
  }

  function egCompareGetStore() {
    var raw = "";
    try {
      raw = window.localStorage ? localStorage.getItem(STORAGE_KEY) : "";
    } catch (e) {}

    var base = {
      byCollection: {}
    };

    if (!raw) return base;

    var parsed = egCompareSafeParse(raw, base);
    if (!parsed.byCollection || typeof parsed.byCollection !== "object") {
      parsed.byCollection = {};
    }

    return parsed;
  }

  function egCompareSaveStore(store) {
    if (!store || typeof store !== "object") return;
    try {
      if (window.localStorage) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
      }
    } catch (e) {}
  }

  function egCompareEnsureBucket(handle) {
    var store = egCompareGetStore();
    handle = String(handle || "").trim();
    if (!handle) return null;

    if (!store.byCollection[handle]) {
      store.byCollection[handle] = {
        selected: [],
        updatedAt: Date.now ? Date.now() : new Date().getTime()
      };
      egCompareSaveStore(store);
    }

    return store.byCollection[handle];
  }

  function egCompareGetSelectedHandles(handle) {
    var store = egCompareGetStore();
    handle = String(handle || "").trim();
    if (!handle) return [];

    var bucket = store.byCollection[handle];
    if (!bucket || !bucket.selected || !bucket.selected.length) return [];

    var out = [];
    for (var i = 0; i < bucket.selected.length; i++) {
      var h = String(bucket.selected[i] || "").trim();
      if (!h) continue;
      if (out.indexOf(h) !== -1) continue;
      out.push(h);
    }
    return out;
  }

  function egCompareSetSelectedHandles(handle, arr) {
    var store = egCompareGetStore();
    handle = String(handle || "").trim();
    if (!handle) return [];

    var clean = [];
    arr = arr || [];

    for (var i = 0; i < arr.length; i++) {
      var h = String(arr[i] || "").trim();
      if (!h) continue;
      if (clean.indexOf(h) !== -1) continue;
      clean.push(h);
    }

    store.byCollection[handle] = {
      selected: clean,
      updatedAt: Date.now ? Date.now() : new Date().getTime()
    };

    egCompareSaveStore(store);
    return clean;
  }

  function egCompareIsSelected(handle, productHandle) {
    var list = egCompareGetSelectedHandles(handle);
    return list.indexOf(String(productHandle || "").trim()) !== -1;
  }

  function egCompareGetMaxItems(root, typeKey) {
    var cfg = window.EG_COLLECTION_COMPARE_CONFIG || {};
    var defaults = cfg.defaults || {};
    var byCollection = cfg.collections || {};
    var byType = cfg.types || {};

    root = root || egCompareGetRoot();

    var handle = egCompareGetCollectionHandle(root);
    var fallback = parseInt(defaults.maxItems, 10);

    if (!isFinite(fallback) || fallback < 2) fallback = 4;

    if (handle && byCollection[handle] && byCollection[handle].maxItems != null) {
      var byHandleMax = parseInt(byCollection[handle].maxItems, 10);
      if (isFinite(byHandleMax) && byHandleMax >= 2) return byHandleMax;
    }

    if (typeKey && byType[typeKey] && byType[typeKey].maxItems != null) {
      var byTypeMax = parseInt(byType[typeKey].maxItems, 10);
      if (isFinite(byTypeMax) && byTypeMax >= 2) return byTypeMax;
    }

    return fallback;
  }

  function egCompareToggle(handle, productHandle) {
    handle = String(handle || "").trim();
    productHandle = String(productHandle || "").trim();

    if (!handle || !productHandle) {
      return { ok: false, reason: "missing" };
    }

    var list = egCompareGetSelectedHandles(handle);
    var idx = list.indexOf(productHandle);

    if (idx !== -1) {
      list.splice(idx, 1);
      egCompareSetSelectedHandles(handle, list);
      return { ok: true, selected: false, list: list };
    }

    if (list.length >= egCompareGetMaxItems(egCompareGetRoot())) {
      return { ok: false, reason: "max", list: list };
    }

    list.push(productHandle);
    egCompareSetSelectedHandles(handle, list);
    return { ok: true, selected: true, list: list };
  }

  function egCompareRemove(handle, productHandle) {
    handle = String(handle || "").trim();
    productHandle = String(productHandle || "").trim();

    var list = egCompareGetSelectedHandles(handle);
    var idx = list.indexOf(productHandle);

    if (idx !== -1) {
      list.splice(idx, 1);
      egCompareSetSelectedHandles(handle, list);
    }

    return list;
  }

  function egCompareClear(handle) {
    handle = String(handle || "").trim();
    egCompareSetSelectedHandles(handle, []);
    return [];
  }

    function egCompareMoveSelected(handle, fromIndex, toIndex) {
    handle = String(handle || "").trim();

    var list = egCompareGetSelectedHandles(handle);
    if (!list.length) return list;

    fromIndex = parseInt(fromIndex, 10);
    toIndex = parseInt(toIndex, 10);

    if (!isFinite(fromIndex) || !isFinite(toIndex)) return list;
    if (fromIndex < 0 || fromIndex >= list.length) return list;
    if (toIndex < 0 || toIndex >= list.length) return list;
    if (fromIndex === toIndex) return list;

    var moved = list.splice(fromIndex, 1)[0];
    list.splice(toIndex, 0, moved);

    egCompareSetSelectedHandles(handle, list);
    return list;
  }

  function egCompareGetTrayEl(root) {
    root = root || egCompareGetRoot();
    if (!root) return null;
    return root.parentNode ? root.parentNode.querySelector("[data-eg-compare-tray]") : null;
  }

  function egCompareEnsureTray(root) {
    root = root || egCompareGetRoot();
    if (!root || !root.parentNode) return null;

    var existing = egCompareGetTrayEl(root);
    if (existing) return existing;

    var tray = document.createElement("div");
    tray.className = "eg-compare-tray";
    tray.setAttribute("data-eg-compare-tray", "");

    tray.innerHTML =
      '<div class="eg-compare-tray__inner">' +
        '<div class="eg-compare-tray__summary">' +
          '<span class="eg-compare-tray__title">Compare</span>' +
          '<span class="eg-compare-tray__count" data-eg-compare-count>0 selected</span>' +
        '</div>' +
        '<div class="eg-compare-tray__items" data-eg-compare-items></div>' +
        '<div class="eg-compare-tray__actions">' +
          '<button type="button" class="eg-compare-tray__clear" data-eg-compare-clear>Clear</button>' +
          '<button type="button" class="eg-compare-tray__open" data-eg-compare-open disabled>Compare</button>' +
        '</div>' +
      '</div>';

    if (root.nextSibling) root.parentNode.insertBefore(tray, root.nextSibling);
    else root.parentNode.appendChild(tray);

    return tray;
  }

  function egCompareBuildChip(handle, productHandle) {
    var map = window.__EG_COMPARE_LITE_MAP || {};
    var p = map[productHandle] || {};

    var title = String(p.title || productHandle || "");
    var img = String(p.image || "");

    var chip = document.createElement("button");
    chip.type = "button";
    chip.className = "eg-compare-chip";
    chip.setAttribute("data-eg-compare-remove", productHandle);
    chip.setAttribute("title", "Remove from compare");

    chip.innerHTML =
      '<span class="eg-compare-chip__media">' +
        (img ? '<img src="' + img + '" alt="">' : '') +
      '</span>' +
      '<span class="eg-compare-chip__text">' + title + '</span>' +
      '<span class="eg-compare-chip__x" aria-hidden="true">×</span>';

    return chip;
  }

    function egCompareNormalizeType(type) {
    return String(type || "").trim().toLowerCase();
  }

  function egCompareGetLiteMap() {
    return window.__EG_COMPARE_LITE_MAP || {};
  }

  function egCompareGetProducts(handle) {
    var map = egCompareGetLiteMap();
    var handles = egCompareGetSelectedHandles(handle);
    var out = [];

    for (var i = 0; i < handles.length; i++) {
      var p = map[handles[i]];
      if (!p) continue;
      out.push(p);
    }

    return out;
  }

  function egCompareGetTypeKeyFromProducts(products) {
    products = products || [];
    if (!products.length) return "";

    var first = egCompareNormalizeType(products[0] && products[0].type);
    if (!first) return "";

    for (var i = 1; i < products.length; i++) {
      if (egCompareNormalizeType(products[i] && products[i].type) !== first) {
        return "";
      }
    }

    return first;
  }

  function egCompareGetConfigForContext(root, typeKey) {
    var cfg = window.EG_COLLECTION_COMPARE_CONFIG || {};
    var handle = egCompareGetCollectionHandle(root);
    var byCollection = cfg.collections || {};
    var byType = cfg.types || {};
    var def = cfg.default || { title: "Compare Products" };

    if (handle && byCollection[handle]) {
      return {
        title: byCollection[handle].title || def.title || "Compare Products",
        groups: [],
        overrides: byCollection[handle].overrides || {},
        directionRules: byCollection[handle].directionRules || {},
        centerHighlights: byCollection[handle].centerHighlights || {}
      };
    }

    if (byType[typeKey]) {
      return {
        title: byType[typeKey].title || def.title || "Compare Products",
        groups: byType[typeKey].groups || [],
        overrides: byType[typeKey].overrides || {},
        directionRules: byType[typeKey].directionRules || {},
        centerHighlights: byType[typeKey].centerHighlights || {}
      };
    }

    return {
      title: def.title || "Compare Products",
      groups: [],
      overrides: {},
      directionRules: {},
      centerHighlights: {}
    };
  }

    function egCompareGetFilterCollectionConfig(handle) {
    var filterCfg = window.EG_COLLECTION_FILTERS || {};
    var collections = filterCfg.collections || {};

    if (handle && collections[handle]) {
      return collections[handle];
    }

    if (handle && filterCfg[handle]) {
      return filterCfg[handle];
    }

    return null;
  }

  function egCompareBuildGroupsFromFilterConfig(handle) {
    var col = egCompareGetFilterCollectionConfig(handle);
    if (!col) return [];

    var compareCfg = window.EG_COLLECTION_COMPARE_CONFIG || {};
    var compareCollections = compareCfg.collections || {};
    var compareOverrides = (handle && compareCollections[handle] && compareCollections[handle].overrides) || {};

    var tagGroups = col.tagGroups || [];
    var tagSets = col.tagGroupSets || [];
    var map = {};
    var i;

    function buildRowFromTagGroup(tg) {
      if (!tg || !tg.key) return null;
      if (String(tg.key).indexOf("nav-") === 0) return null;

      var match = tg.match || {};
      var tags = [];
      var excludeStartsWith = [];
      var override = compareOverrides[tg.key] || null;
      if (override && override.hide === true) return null;

      if (match.startsWith) {
        tags.push(match.startsWith);
      }

      if (match.onlyTags && match.onlyTags.length) {
        for (var k = 0; k < match.onlyTags.length; k++) {
          tags.push(match.onlyTags[k]);
        }
      }

      if (match.excludeStartsWith && match.excludeStartsWith.length) {
        for (var x = 0; x < match.excludeStartsWith.length; x++) {
          excludeStartsWith.push(match.excludeStartsWith[x]);
        }
      }

      if (override && override.tags && override.tags.length) {
        tags = [];
        for (var t = 0; t < override.tags.length; t++) {
          tags.push(override.tags[t]);
        }
      }

      if (override && override.excludeStartsWith && override.excludeStartsWith.length) {
        excludeStartsWith = [];
        for (var e = 0; e < override.excludeStartsWith.length; e++) {
          excludeStartsWith.push(override.excludeStartsWith[e]);
        }
      }

      if (!tags.length) return null;

      return {
        key: tg.key,
        label: (override && override.label) || tg.label || tg.key,
        tags: tags,
        excludeStartsWith: excludeStartsWith
      };
    }

    for (i = 0; i < tagGroups.length; i++) {
      var g = tagGroups[i];
      if (!g || !g.key) continue;
      map[g.key] = g;
    }

    var groups = [];

    // build grouped compare sections from tagGroupSets
    for (i = 0; i < tagSets.length; i++) {
      var set = tagSets[i];
      if (!set || !set.children || !set.children.length) continue;

      var rows = [];
      for (var j = 0; j < set.children.length; j++) {
        var key = set.children[j];
        var tg = map[key];
        var row = buildRowFromTagGroup(tg);
        if (!row) continue;
        rows.push(row);
      }

      if (rows.length) {
        groups.push({
          key: set.key,
          label: set.label || set.key,
          rows: rows
        });
      }
    }

    // add standalone visible groups not already in sets
    for (i = 0; i < tagGroups.length; i++) {
      var tg2 = tagGroups[i];
      if (!tg2 || !tg2.key) continue;
      if (String(tg2.key).indexOf("nav-") === 0) continue;

      var inSet = false;
      for (var s = 0; s < tagSets.length; s++) {
        var children = tagSets[s] && tagSets[s].children ? tagSets[s].children : [];
        if (children.indexOf(tg2.key) !== -1) {
          inSet = true;
          break;
        }
      }

      if (inSet) continue;

      var standaloneRow = buildRowFromTagGroup(tg2);
      if (!standaloneRow) continue;

      groups.push({
        key: tg2.key,
        label: tg2.label || tg2.key,
        rows: [standaloneRow]
      });
    }

    return groups;
  }

    function egCompareFlattenRowsFromGroups(groups) {
    var out = [];
    groups = groups || [];

    for (var i = 0; i < groups.length; i++) {
      var rows = groups[i] && groups[i].rows ? groups[i].rows : [];
      for (var j = 0; j < rows.length; j++) {
        out.push(rows[j]);
      }
    }

    return out;
  }

function egCompareGetMatchConfigForContext(root, typeKey) {
  var cfg = window.EG_COLLECTION_COMPARE_MATCH_CONFIG || {};
  var handle = egCompareGetCollectionHandle(root);
  var byCollection = cfg.collections || {};
  var byType = cfg.types || {};
  var def = cfg.default || {};

  var out = {
    fields: [],
    weightedFields: [],
    excludeIfAllMatch: [],
    excludeIfAnyDiff: [],
    scoreAdjusters: [],
    fieldDefs: {},
    requireSameType: true
  };

  function copyFieldDefs(srcDefs) {
    if (!srcDefs) return;
    for (var k in srcDefs) {
      if (!srcDefs.hasOwnProperty(k)) continue;
      out.fieldDefs[k] = srcDefs[k];
    }
  }

  function applyFrom(src) {
    var i;
    if (!src) return;

    if (src.fields && src.fields.length) {
      out.fields = src.fields.slice(0);
    }

    if (src.weightedFields && src.weightedFields.length) {
      out.weightedFields = src.weightedFields.slice(0);
    }

    if (src.excludeIfAllMatch && src.excludeIfAllMatch.length) {
      out.excludeIfAllMatch = src.excludeIfAllMatch.slice(0);
    }

    if (src.excludeIfAnyDiff && src.excludeIfAnyDiff.length) {
      out.excludeIfAnyDiff = src.excludeIfAnyDiff.slice(0);
    }

    if (src.scoreAdjusters && src.scoreAdjusters.length) {
      out.scoreAdjusters = src.scoreAdjusters.slice(0);
    }

    if (src.fieldDefs) {
      copyFieldDefs(src.fieldDefs);
    }

    if (src.requireSameType === false) {
      out.requireSameType = false;
    }
  }

  applyFrom(def);
  if (byType[typeKey]) applyFrom(byType[typeKey]);
  if (handle && byCollection[handle]) applyFrom(byCollection[handle]);

  if (!out.weightedFields.length && out.fields.length) {
    for (var i = 0; i < out.fields.length; i++) {
      out.weightedFields.push({ key: out.fields[i], weight: 1 });
    }
  }

  return out;
}

  function egCompareFieldEquals(aMap, bMap, key) {
  var a = egCompareNormalize(aMap[key]);
  var b = egCompareNormalize(bMap[key]);
  if (!a && !b) return null;
  return !!(a && b && a === b);
}

function egCompareMergeMatchOnlyRows(rows, matchCfg) {
  var out = rows ? rows.slice(0) : [];
  var seen = {};
  var keys = [];
  var i;
  var k;

  for (i = 0; i < out.length; i++) {
    if (out[i] && out[i].key) {
      seen[out[i].key] = true;
    }
  }

  function collectKey(key) {
    key = String(key || "").trim();
    if (!key) return;
    if (seen[key]) return;
    if (keys.indexOf(key) !== -1) return;
    keys.push(key);
  }

  var weightedFields = (matchCfg && matchCfg.weightedFields) ? matchCfg.weightedFields : [];
  for (i = 0; i < weightedFields.length; i++) {
    if (weightedFields[i] && weightedFields[i].key) collectKey(weightedFields[i].key);
  }

  var excludeIfAllMatch = (matchCfg && matchCfg.excludeIfAllMatch) ? matchCfg.excludeIfAllMatch : [];
  for (i = 0; i < excludeIfAllMatch.length; i++) collectKey(excludeIfAllMatch[i]);

  var excludeIfAnyDiff = (matchCfg && matchCfg.excludeIfAnyDiff) ? matchCfg.excludeIfAnyDiff : [];
  for (i = 0; i < excludeIfAnyDiff.length; i++) collectKey(excludeIfAnyDiff[i]);

  var scoreAdjusters = (matchCfg && matchCfg.scoreAdjusters) ? matchCfg.scoreAdjusters : [];
  for (i = 0; i < scoreAdjusters.length; i++) {
    if (scoreAdjusters[i] && scoreAdjusters[i].key) collectKey(scoreAdjusters[i].key);
  }

  var fieldDefs = (matchCfg && matchCfg.fieldDefs) ? matchCfg.fieldDefs : {};

  for (i = 0; i < keys.length; i++) {
    k = keys[i];
    if (!fieldDefs[k]) continue;

    out.push({
      key: k,
      label: "",
      matcher: fieldDefs[k],
      hiddenMatchOnly: true
    });
  }

  return out;
}

function egCompareApplyScoreAdjusters(score, aMap, bMap, adjusters) {
  var out = Number(score || 0);
  var i;

  for (i = 0; i < adjusters.length; i++) {
    var rule = adjusters[i];
    if (!rule || !rule.key) continue;

    var eq = egCompareFieldEquals(aMap, bMap, rule.key);
    if (eq === null) continue;

    if (eq && rule.when === "match") {
      out += Number(rule.amount || 0);
    } else if (!eq && rule.when === "diff") {
      out += Number(rule.amount || 0);
    }
  }

  return out;
}

    function egCompareNormalize(str) {
    return String(str || "").trim().toLowerCase();
  }

  function egCompareGetAutoFamilyKey(p) {
  if (!p) return "";

  var vendor = egCompareNormalize(p.vendor);
  var type = egCompareNormalize(p.type);
  var title = egCompareNormalize(p.title || p.handle);

  if (!vendor || !type || !title) return "";

  title = title
    .replace(/&/g, " and ")
    .replace(/\([^)]*\)/g, " ")
    .replace(/\[[^\]]*\]/g, " ")
    .replace(/\b(open box|pre order|pre-order|latest edition|new edition|gaming|wireless|wired|optical|mechanical|magnetic|keyboard|mouse|mousepad|mouse pad|gaming mouse|gaming keyboard|gaming mousepad)\b/g, " ")
.replace(/\b(black|white|red|blue|green|yellow|pink|purple|orange|grey|gray|silver|gold|clear|transparent|smoke|shadow|midnight|cloud|rose|frost|ice|snow|berry|matcha|navy|beige|classic|daybreak|doom|edition|pure)\b/g, " ")    .replace(/\b(uk|us|iso|ansi|de|fr|jp|layout)\b/g, " ")
    .replace(/\b(switch|switches|linear|tactile|clicky|crystalblade|jade|silver|magnetic jade|hall effect)\b/g, " ")
    .replace(/\b(xs|small|medium|large|xl|xxl|3xl|4xl|mini|max|pro|max|plus|v1|v2|v3)\b/g, " ")
    .replace(/\b\d+k\b/g, " ")
    .replace(/\b\d+hz\b/g, " ")
    .replace(/\b\d+g\b/g, " ")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!title || title.length < 4) return "";

  return vendor + "|" + type + "|" + title;
}

function egCompareIsLikelySameAutoFamily(a, b) {
  var ak = egCompareGetAutoFamilyKey(a);
  var bk = egCompareGetAutoFamilyKey(b);

  if (!ak || !bk) return false;
  return ak === bk;
}

  function egCompareExtractFromTags(tags, prefixes, excludeStartsWith) {
    tags = tags || [];
    prefixes = prefixes || [];
    excludeStartsWith = excludeStartsWith || [];

    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i] || "").trim();
      var tl = t.toLowerCase();

      for (var j = 0; j < prefixes.length; j++) {
        var p = String(prefixes[j] || "").trim();
        var pl = p.toLowerCase();

        // Skip excluded prefixes first
        var blocked = false;
        for (var x = 0; x < excludeStartsWith.length; x++) {
          var ex = String(excludeStartsWith[x] || "").trim().toLowerCase();
          if (ex && tl.indexOf(ex) === 0) {
            blocked = true;
            break;
          }
        }

        if (blocked) continue;

        // Prefix match using the prefix exactly as configured
        if (tl.indexOf(pl) === 0) {
          var raw = String(t.slice(p.length) || "").trim();

          // If the tag uses an extra underscore variant (e.g. Game Type__...),
          // remove any leftover leading underscores from the display value.
          raw = raw.replace(/^_+/, "").trim();

          if (raw) return raw;
          return t;
        }

        // exact match fallback
        if (tl === pl) {
          return t;
        }
      }
    }

    return "";
  }

  function egCompareBuildProductFieldMap(p, rows) {
    var map = {};
    var tags = (p && p.tags) || [];

    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (!r || !r.key) continue;

      var val = egCompareExtractFromTags(tags, r.tags || [], r.excludeStartsWith || []);
      map[r.key] = val;
    }

    return map;
  }

  function egCompareFormatPrice(p) {
    if (!p) return "";

    var currency = String(p.currency || "GBP");
    var min = p.price_min;
    var max = p.price_max;
    var prefix = currency === "GBP" ? "£" : "";

    if (min === undefined || min === null || min === "") return "";

    if (typeof egFormatMoney === "function") {
      if (String(max) !== "" && String(max) !== String(min)) {
        return egFormatMoney(min, currency) + " - " + egFormatMoney(max, currency);
      }
      return egFormatMoney(min, currency);
    }

    var minNum = parseFloat(min);
    var maxNum = parseFloat(max);

    if (String(max) !== "" && String(max) !== String(min)) {
      if (!isNaN(minNum) && !isNaN(maxNum)) {
        return prefix + minNum.toFixed(2) + " - " + prefix + maxNum.toFixed(2);
      }
      return prefix + String(min) + " - " + prefix + String(max);
    }

    if (!isNaN(minNum)) {
      return prefix + minNum.toFixed(2);
    }

    return prefix + String(min);
  }

  function egCompareVariantIdToNumeric(raw) {
    var s = String(raw || "").replace(/^\s+|\s+$/g, "");
    if (!s) return "";

    var idx = s.lastIndexOf("/");
    if (idx >= 0) {
      s = s.slice(idx + 1);
    }

    s = s.replace(/[^\d]/g, "");
    return s;
  }

function egCompareGetVariantId(p) {
  var raw =
    p && (
      p.variant_id ||
      p.variantId ||
      p.first_variant_id ||
      p.firstVariantId ||
      p.selected_or_first_available_variant_id ||
      p.selectedOrFirstAvailableVariantId
    ) || "";

  return egCompareVariantIdToNumeric(raw);
}

function egCompareBuildThemeAddForm(p, available) {
  var variantId = egCompareGetVariantId(p);
  var tags = (p && p.tags && p.tags.length) ? p.tags : [];
  var isPreorder = false;
  var i;
  var btnClass = "button button--primary eg-compare-modal__hover-btn";
  var btnText = "Add to Bag";
  var handle = String(p && p.handle || "");
  var isLegacy = egCompareIsLegacyProduct(p);

  if (isLegacy) {
    return "";
  }

  if (!available || !variantId) {
    return '<button type="button" class="eg-compare-modal__hover-btn eg-compare-modal__hover-btn--soldout" disabled>Sold out</button>';
  }

  for (i = 0; i < tags.length; i++) {
    var tt = String(tags[i] || "").toLowerCase();
    if (tt === "pre-order" || tt === "preorder") {
      isPreorder = true;
      break;
    }
  }

  if (isPreorder) {
    btnClass = "button button--preorder eg-compare-modal__hover-btn";
    btnText = "Pre-Order";
  }

  return ''
    + '<button'
    + ' type="button"'
    + ' class="' + btnClass + '"'
    + ' data-eg-compare-add-to-bag="' + handle + '"'
    + ' data-eg-compare-variant-id="' + variantId + '"'
    + '>'
    + btnText
    + '</button>';
}

  function egCompareGetModalEl() {
    return document.querySelector("[data-eg-compare-modal]");
  }

  function egCompareEnsureModal() {
    var existing = egCompareGetModalEl();
    if (existing) return existing;

    var modal = document.createElement("div");
    modal.className = "eg-compare-modal";
    modal.setAttribute("data-eg-compare-modal", "");
    modal.setAttribute("aria-hidden", "true");

    modal.innerHTML =
      '<div class="eg-compare-modal__backdrop" data-eg-compare-close></div>' +
      '<div class="eg-compare-modal__dialog" role="dialog" aria-modal="true" aria-label="Compare products">' +
        '<div class="eg-compare-modal__header">' +
          '<div class="eg-compare-modal__headermain">' +
            '<div class="eg-compare-modal__titlewrap">' +
              '<h2 class="eg-compare-modal__title" data-eg-compare-modal-title>Compare Products</h2>' +
              '<p class="eg-compare-modal__subtitle" data-eg-compare-modal-subtitle></p>' +
            '</div>' +
            '<div class="eg-compare-modal__searcharea" data-eg-compare-modal-searcharea></div>' +
          '</div>' +
          '<button type="button" class="eg-compare-modal__close" data-eg-compare-close aria-label="Close">×</button>' +
        '</div>' +
        '<div class="eg-compare-modal__body">' +
          '<div class="eg-compare-modal__hero" data-eg-compare-modal-hero>' +
            '<div class="eg-compare-modal__products" data-eg-compare-modal-products></div>' +
            '<div class="eg-compare-modal__meta" data-eg-compare-modal-meta></div>' +
          '</div>' +
          '<div class="eg-compare-modal__status" data-eg-compare-modal-status></div>' +
          '<div class="eg-compare-modal__tablewrap">' +
            '<div class="eg-compare-modal__table" data-eg-compare-modal-table></div>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);
    return modal;
  }

  function egCompareCloseModal() {
    var modal = egCompareGetModalEl();
    if (!modal) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("eg-compare-modal-open");
    document.body.classList.remove("eg-compare-modal-open");
  }

    function egCompareSetModalStatus(msg, isError) {
    var modal = egCompareGetModalEl();
    if (!modal) return;

    var statusEl = modal.querySelector("[data-eg-compare-modal-status]");
    if (!statusEl) return;

    if (!msg) {
      statusEl.innerHTML = "";
      return;
    }

    statusEl.innerHTML =
      '<div class="eg-compare-modal__status-msg' + (isError ? ' is-error' : ' is-success') + '">' +
        msg +
      '</div>';
  }

    function egCompareEscapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function egCompareGetModalSearchQuery(modal) {
    if (!modal) return "";
    return String(modal.__egCompareSearchQuery || "").trim();
  }

  function egCompareSetModalSearchQuery(modal, q) {
    if (!modal) return;
    modal.__egCompareSearchQuery = String(q || "");
  }

  function egCompareGetSearchCandidates(handle, targetTypeKey, query) {
    var map = egCompareGetLiteMap();
    var selected = egCompareGetSelectedHandles(handle);
    var selectedMap = {};
    var out = [];
    var q = String(query || "").toLowerCase().replace(/\s+/g, " ").trim();
    var k;

    for (k = 0; k < selected.length; k++) {
      selectedMap[String(selected[k] || "").trim()] = true;
    }

    for (k in map) {
      if (!map.hasOwnProperty(k)) continue;

      var p = map[k];
      if (!p || !p.handle) continue;

      var productHandle = String(p.handle || "").trim();
      if (!productHandle) continue;
      if (selectedMap[productHandle]) continue;

      if (targetTypeKey) {
        var pTypeKey = egCompareNormalizeType(p.type);
        if (pTypeKey !== targetTypeKey) continue;
      }

      var title = String(p.title || "").trim();
      var vendor = String(p.vendor || "").trim();
      var hay = (title + " " + vendor).toLowerCase().replace(/\s+/g, " ").trim();

      if (q && hay.indexOf(q) === -1) continue;

      out.push(p);
    }

    out.sort(function (a, b) {
      var at = String(a && a.title || "").toLowerCase();
      var bt = String(b && b.title || "").toLowerCase();

      if (q) {
        var aStarts = at.indexOf(q) === 0 ? 1 : 0;
        var bStarts = bt.indexOf(q) === 0 ? 1 : 0;
        if (aStarts !== bStarts) return bStarts - aStarts;
      }

      return at < bt ? -1 : (at > bt ? 1 : 0);
    });

    return out;
  }

  function egCompareBuildSearchResultCard(p) {
    var title = String(p && p.title || "");
    var img = String(p && p.image || "");
    var vendor = String(p && p.vendor || "");
    var price = egCompareFormatPrice(p);
    var handle = String(p && p.handle || "");
    var available = !!(p && (p.variant_available || p.available));

    return ''
      + '<button type="button" class="eg-compare-modal__search-result" data-eg-compare-modal-add="' + egCompareEscapeHtml(handle) + '">'
      +   '<span class="eg-compare-modal__search-result-media">'
      +     (img ? '<img src="' + egCompareEscapeHtml(img) + '" alt="">' : '')
      +   '</span>'
      +   '<span class="eg-compare-modal__search-result-main">'
      +     '<span class="eg-compare-modal__search-result-title">' + egCompareEscapeHtml(title) + '</span>'
      +     (vendor ? '<span class="eg-compare-modal__search-result-vendor">' + egCompareEscapeHtml(vendor) + '</span>' : '')
      +   '</span>'
      +   '<span class="eg-compare-modal__search-result-side">'
      +     '<span class="eg-compare-modal__search-result-price">' + egCompareEscapeHtml(price) + '</span>'
      +     '<span class="eg-compare-modal__search-result-stock ' + (available ? 'is-instock' : 'is-oos') + '">' + (available ? 'In stock' : 'Out of stock') + '</span>'
      +   '</span>'
      + '</button>';
  }

function egCompareRenderModalSearch(root, modal, products, typeKey) {
  if (!root || !modal) return;

  var searchArea = modal.querySelector("[data-eg-compare-modal-searcharea]");
  if (!searchArea) return;

  var handle = egCompareGetCollectionHandle(root);
  var selected = egCompareGetSelectedHandles(handle);
  var max = egCompareGetMaxItems(root, typeKey);
  var remaining = Math.max(0, max - selected.length);

  if (selected.length >= max) {
    searchArea.innerHTML = "";
    searchArea.style.display = "none";
    searchArea.__egBuilt = false;
    return;
  }

  searchArea.style.display = "";

  var query = egCompareGetModalSearchQuery(modal);
  var q = String(query || "").replace(/\s+/g, " ").trim();
  var targetTypeKey = typeKey;

  if (!targetTypeKey && products && products.length) {
    targetTypeKey = egCompareNormalizeType(products[0] && products[0].type);
  }

  var input = searchArea.querySelector("[data-eg-compare-modal-search-input]");
  var dropdown = searchArea.querySelector("[data-eg-compare-modal-search-dropdown]");

  if (!searchArea.__egBuilt || !input || !dropdown) {
    searchArea.innerHTML =
      '<div class="eg-compare-modal__searchbox">' +
        '<input type="search" class="eg-compare-modal__searchinput" data-eg-compare-modal-search-input placeholder="Search products to add" autocomplete="off" spellcheck="false">' +
        '<div class="eg-compare-modal__searchdropdown" data-eg-compare-modal-search-dropdown style="display:none;"></div>' +
      '</div>';

    searchArea.__egBuilt = true;
    input = searchArea.querySelector("[data-eg-compare-modal-search-input]");
    dropdown = searchArea.querySelector("[data-eg-compare-modal-search-dropdown]");
  }
  if (!input || !dropdown) return;

  if (input.value !== q) {
    input.value = q;
  }

  input.setAttribute("placeholder", remaining > 0 ? ("Add up to " + remaining + " more") : "Compare full");

  if (!q) {
    dropdown.innerHTML = "";
    dropdown.style.display = "none";
    return;
  }

  var results = egCompareGetSearchCandidates(handle, targetTypeKey, q);
  var html = "";
  var i;
  var limit = 8;

  if (targetTypeKey) {
    html += '<div class="eg-compare-modal__searchmeta">Same category only</div>';
  }

  if (!results.length) {
    html += '<div class="eg-compare-modal__searchempty">No matching products found.</div>';
  } else {
    html += '<div class="eg-compare-modal__searchresults">';
    for (i = 0; i < results.length && i < limit; i++) {
      html += egCompareBuildSearchResultCard(results[i]);
    }
    html += '</div>';
  }

  dropdown.innerHTML = html;
  dropdown.style.display = "block";
}

function egCompareClearModalSearch(modal) {
  if (!modal) return;

  egCompareSetModalSearchQuery(modal, "");

  var input = modal.querySelector("[data-eg-compare-modal-search-input]");
  var dropdown = modal.querySelector("[data-eg-compare-modal-search-dropdown]");

  if (input) input.value = "";
  if (dropdown) {
    dropdown.innerHTML = "";
    dropdown.style.display = "none";
  }
}

  function egCompareAddHandle(handle, productHandle) {
    handle = String(handle || "").trim();
    productHandle = String(productHandle || "").trim();

    if (!handle || !productHandle) return false;

    var list = egCompareGetSelectedHandles(handle);
    if (list.indexOf(productHandle) !== -1) return false;
    if (list.length >= egCompareGetMaxItems(egCompareGetRoot())) return false;

    list.push(productHandle);
    egCompareSetSelectedHandles(handle, list);
    return true;
  }

  function egCompareGetRowsForType(root, typeKey) {
  var cfg = egCompareGetConfigForContext(root, typeKey);
  var handle = egCompareGetCollectionHandle(root);
  var dynamicGroups = egCompareBuildGroupsFromFilterConfig(handle);

  if (!dynamicGroups.length && cfg && cfg.groups && cfg.groups.length) {
    dynamicGroups = cfg.groups;
  }

  return egCompareFlattenRowsFromGroups(dynamicGroups || []);
}

function egCompareScorePair(root, baseProduct, candidateProduct, typeKey) {
  var scores = egCompareCalculateMatch(root, [baseProduct, candidateProduct], typeKey);
  if (scores && scores.length) {
    var score = Number(scores[0] || 0);

    if (
      score >= 100 &&
      !egCompareIsLikelySameAutoFamily(baseProduct, candidateProduct)
    ) {
      score = 98;
    }

    return score;
  }
  
  var matchCfg = egCompareGetMatchConfigForContext(root, typeKey);
  var rows = egCompareGetRowsForType(root, typeKey);
  rows = egCompareMergeMatchOnlyRows(rows, matchCfg);
  if (!rows.length) return 0;

  var aMap = egCompareBuildProductFieldMap(baseProduct, rows);
  var bMap = egCompareBuildProductFieldMap(candidateProduct, rows);

  var total = 0;
  var match = 0;

  for (var i = 0; i < rows.length; i++) {
    var key = rows[i] && rows[i].key ? rows[i].key : "";
    if (!key) continue;

    var a = egCompareNormalize(aMap[key]);
    var b = egCompareNormalize(bMap[key]);

    if (!a && !b) continue;

    total++;
    if (a && b && a === b) match++;
  }

  return total ? Math.round((match / total) * 100) : 0;
}

function egCompareIsDbModeOn() {
  var sp = new URLSearchParams(window.location.search || "");
  return sp.get("eg_show_legacy") === "1";
}

function egCompareIsOpenBoxProduct(p) {
  var title = String(p && p.title || "").toLowerCase();
  var handle = String(p && p.handle || "").toLowerCase();
  var tags = (p && p.tags) || [];
  var i;

  if (title.indexOf("open box") !== -1) return true;
  if (title.indexOf("open-box") !== -1) return true;
  if (handle.indexOf("open-box") !== -1) return true;

  for (i = 0; i < tags.length; i++) {
    var t = String(tags[i] || "").toLowerCase();
    if (t === "open box" || t === "open-box" || t === "open_box") return true;
  }

  return false;
}

function egCompareIsLegacyProduct(p) {
  var v = (p && p.legacy_collection !== undefined) ? p.legacy_collection : null;
  return (v === true || v === 1 || v === "1" || v === "true");
}

function egCompareBuildLegacyBadgeHtml() {
  return '<div class="eg-compare-modal__legacy-badge">Not sold here</div>';
}

function egCompareFindTopMatches(root, baseHandle, limit) {
  root = root || egCompareGetRoot();

  var map = egCompareGetLiteMap();
  var base = map[String(baseHandle || "").trim()];
  var out = [];
  var k;

  if (!base || !base.handle) return out;

  var typeKey = egCompareNormalizeType(base.type);
  if (!typeKey) return out;

  var matchCfg = egCompareGetMatchConfigForContext(root, typeKey);
  var dbOn = egCompareIsDbModeOn();

  for (k in map) {
    if (!map.hasOwnProperty(k)) continue;

    var p = map[k];
    var score;

    if (!p || !p.handle) continue;
    if (String(p.handle) === String(base.handle)) continue;
    if (egCompareIsLikelySameAutoFamily(base, p)) continue;
    if (egCompareIsOpenBoxProduct(p)) continue;

    // DB Mode off = only search EG-range products
    if (!dbOn && egCompareIsLegacyProduct(p)) continue;

    if (matchCfg.requireSameType !== false && egCompareNormalizeType(p.type) !== typeKey) continue;

    score = egCompareScorePair(root, base, p, typeKey);
    if (score < 0) continue;

    out.push({
      product: p,
      score: score,
      available: !!(p.variant_available || p.available),
      title: String(p.title || "").toLowerCase()
    });
  }

  out.sort(function (a, b) {
    // DB Mode ON = pure similarity ranking
    if (dbOn) {
      if (a.score !== b.score) return b.score - a.score;
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
      return 0;
    }

    // DB Mode OFF = keep buyable products first
    if (a.available !== b.available) return a.available ? -1 : 1;
    if (a.score !== b.score) return b.score - a.score;
    if (a.title < b.title) return -1;
    if (a.title > b.title) return 1;
    return 0;
  });

  var picks = [];
  var max = Math.max(0, parseInt(limit, 10) || 0);

  var pickedFamilyKeys = {};

  for (var i = 0; i < out.length && picks.length < max; i++) {
    var candidate = out[i].product;
    var familyKey = egCompareGetAutoFamilyKey(candidate);

    if (familyKey && pickedFamilyKeys[familyKey]) continue;

    picks.push(candidate);

    if (familyKey) {
      pickedFamilyKeys[familyKey] = true;
    }
  }

  return picks;
}

function egCompareOpenWithSimilar(root, baseHandle) {
  root = root || egCompareGetRoot();

  var collectionHandle = egCompareGetCollectionHandle(root);
  var map = egCompareGetLiteMap();
  var base = map[String(baseHandle || "").trim()];

  if (!collectionHandle || !base || !base.handle) return;

  var picks = egCompareFindTopMatches(root, base.handle, 3);
  var next = [String(base.handle)];

  for (var i = 0; i < picks.length; i++) {
    if (!picks[i] || !picks[i].handle) continue;
    next.push(String(picks[i].handle));
  }

  if (next.length < 2) {
    window.alert("No similar products found in this collection.");
    return;
  }

  egCompareSetSelectedHandles(collectionHandle, next);
  egCompareRenderTray(root);
  egCompareOpenModal(root);
}

function egCompareEnsureFindSimilarButtons(root) {
  root = root || egCompareGetRoot();
  if (!root) return;

  var compareBtns = document.querySelectorAll("[data-eg-compare-toggle]");

  for (var i = 0; i < compareBtns.length; i++) {
    var compareBtn = compareBtns[i];
    if (!compareBtn) continue;

    var productHandle = String(compareBtn.getAttribute("data-eg-compare-handle") || "").trim();
    if (!productHandle) continue;

    var host = compareBtn.parentNode;
    if (host && host.classList && host.classList.contains("eg-compare-card-actions-row")) {
      host = host.parentNode;
    }
    if (!host) continue;

    var existing = host.querySelector('[data-eg-compare-find-similar="' + productHandle + '"]');
    if (existing) continue;

    var similarBtn = document.createElement("button");
    similarBtn.type = "button";
    similarBtn.className = "eg-compare-card-toggle eg-compare-card-toggle--similar";
    similarBtn.setAttribute("data-eg-compare-find-similar", productHandle);
    similarBtn.setAttribute("aria-label", "Find similar products");

    similarBtn.innerHTML =
      '<span class="eg-compare-card-toggle__text">Find Similar</span>';

    if (compareBtn.nextSibling) host.insertBefore(similarBtn, compareBtn.nextSibling);
    else host.appendChild(similarBtn);
  }
}

function egCompareFindLiveCardForm(productHandle, variantId) {
  var toggles = document.querySelectorAll('[data-eg-compare-toggle][data-eg-compare-handle]');
  var i;

  for (i = 0; i < toggles.length; i++) {
    var tg = toggles[i];
    if (!tg) continue;
    if (String(tg.getAttribute("data-eg-compare-handle") || "").trim() !== String(productHandle || "").trim()) continue;

    var tile = tg.closest ? tg.closest(".product-item") : null;
    if (!tile) continue;

    var form = tile.querySelector('form[action*="/cart/add"]');
    if (!form) continue;

    var idInput = form.querySelector('input[name="id"]');
    var submit = form.querySelector('button[type="submit"], input[type="submit"]');

    if (!submit || submit.disabled) continue;

    if (variantId) {
      if (!idInput) continue;
      if (String(idInput.value || "").trim() !== String(variantId || "").trim()) continue;
    }

    return form;
  }

  return null;
}

function egCompareOpenCartDrawer() {
  var toggle =
    document.querySelector('[data-action="toggle-cart"]') ||
    document.querySelector('[data-action="open-cart"]') ||
    document.querySelector('.site-header__cart-toggle');

  if (toggle && typeof toggle.click === "function") {
    toggle.click();
    return true;
  }

  try {
    document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
  } catch (e1) {}

  try {
    document.dispatchEvent(new CustomEvent("theme:cart:open", { bubbles: true }));
  } catch (e2) {}

  try {
    window.dispatchEvent(new CustomEvent("cart:open"));
  } catch (e3) {}

  try {
    window.dispatchEvent(new CustomEvent("theme:cart:open"));
  } catch (e4) {}

  return false;
}

function egCompareSyncCartUi() {
  return fetch("/cart.js", {
    credentials: "same-origin",
    headers: {
      "Accept": "application/json"
    }
  })
    .then(function (res) {
      if (!res.ok) throw new Error("cart sync failed");
      return res.json();
    })
    .then(function (cart) {
      var count = cart && typeof cart.item_count === "number" ? cart.item_count : 0;

      var selectors = [
        "[data-cart-count]",
        "[data-header-cart-count]",
        ".site-header__cart-count",
        ".header__cart-count",
        ".cart-count",
        ".cart-link__count",
        ".site-header__cart-indicator"
      ];

      for (var s = 0; s < selectors.length; s++) {
        var nodes = document.querySelectorAll(selectors[s]);
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].textContent = String(count);
        }
      }

      var wrappers = document.querySelectorAll(
        ".site-header__cart-count, .header__cart-count, .cart-count, .cart-link__count, .site-header__cart-indicator"
      );

      for (var j = 0; j < wrappers.length; j++) {
        var el = wrappers[j];
        if (!el || !el.classList) continue;
        el.classList.toggle("is-hidden", count <= 0);
        el.classList.toggle("hidden", count <= 0);
      }

      return cart;
    });
}

function egCompareRefreshCartSections() {
  var roots = [];
  var selectors = [
    ".cart-drawer",
    "[data-cart-drawer]",
    ".drawer--cart",
    ".mini-cart",
    "#mini-cart",
    "#cart-drawer",
    ".sidebar-menu__cart"
  ];

  function pushRoot(el) {
    if (!el) return;
    if (roots.indexOf(el) !== -1) return;
    roots.push(el);
  }

  for (var s = 0; s < selectors.length; s++) {
    var found = document.querySelectorAll(selectors[s]);
    for (var i = 0; i < found.length; i++) {
      pushRoot(found[i]);
    }
  }

  var sectionKeys = [];
  var targets = [];

  for (var r = 0; r < roots.length; r++) {
    var root = roots[r];
    var sectionEl = root.closest ? root.closest('[id^="shopify-section-"]') : null;
    if (!sectionEl) continue;

    var rawId = String(sectionEl.id || "");
    var key = rawId.replace(/^shopify-section-/, "").trim();
    if (!key) continue;

    if (sectionKeys.indexOf(key) === -1) {
      sectionKeys.push(key);
    }

    targets.push({
      root: root,
      sectionKey: key
    });
  }

  if (!sectionKeys.length) {
    return Promise.resolve(null);
  }

  return fetch("/?sections=" + encodeURIComponent(sectionKeys.join(",")), {
    credentials: "same-origin",
    headers: {
      "Accept": "application/json"
    }
  })
    .then(function (res) {
      if (!res.ok) throw new Error("section refresh failed");
      return res.json();
    })
    .then(function (json) {
      for (var j = 0; j < targets.length; j++) {
        var target = targets[j];
        var html = json && json[target.sectionKey] ? String(json[target.sectionKey]) : "";
        if (!html) continue;

        var wrap = document.createElement("div");
        wrap.innerHTML = html;

        var freshRoot = null;
        var currentRoot = target.root;

        for (var s2 = 0; s2 < selectors.length; s2++) {
          if (!freshRoot) {
            freshRoot = wrap.querySelector(selectors[s2]);
          }
        }

        if (!freshRoot || !currentRoot) continue;

        currentRoot.innerHTML = freshRoot.innerHTML;
      }

      return json;
    });
}

function egCompareHandleProxyAddButton(btn) {
  if (!btn || btn.disabled) return;

  var variantId = egCompareVariantIdToNumeric(
    btn.getAttribute("data-eg-compare-variant-id") || ""
  );

  if (!variantId) {
    egCompareSetModalStatus("Variant unavailable.", true);
    return;
  }

  btn.disabled = true;
  egCompareSetModalStatus("Adding to bag...", false);

  fetch("/cart/add.js", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: 1
    })
  })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (json) {
          throw json;
        });
      }
      return res.json();
    })
    .then(function () {
      return egCompareSyncCartUi();
    })
    .then(function () {
      return egCompareRefreshCartSections().catch(function () {
        return null;
      });
    })
    .then(function () {
      egCompareSetModalStatus("Added to bag.", false);

      setTimeout(function () {
        egCompareOpenCartDrawer();
      }, 80);

      setTimeout(function () {
        egCompareSetModalStatus("", false);
      }, 1200);
    })
    .catch(function (err) {
      var msg = "Unable to add to bag.";
      if (err && err.description) msg = String(err.description);
      else if (err && err.message) msg = String(err.message);

      egCompareSetModalStatus(msg, true);
    })
    .then(function () {
      setTimeout(function () {
        btn.disabled = false;
      }, 300);
    });
}

  function egCompareBindModalCartProxy() {
    if (document.__egCompareModalCartProxyBound) return;
    document.__egCompareModalCartProxyBound = true;

    document.addEventListener("click", function (e) {
      var btn = e.target && e.target.closest ? e.target.closest("[data-eg-compare-add-to-bag]") : null;
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      egCompareHandleProxyAddButton(btn);
    }, true);
  }

  function egCompareBuildModalProductCard(p, matchPct, isBaseProduct, itemIndex, totalItems) {
    var el = document.createElement("div");
    el.className = "eg-compare-modal__product" + (isBaseProduct ? " is-primary" : "");

    var title = String(p && p.title || "");
    var img = String(p && p.image || "");
    var isLegacy = egCompareIsLegacyProduct(p);
    var price = isLegacy ? "" : egCompareFormatPrice(p);
    var available = !!(p && (p.variant_available || p.available));

    var handle = String(p && p.handle || "");
    var productUrl = String((p && p.url) || (handle ? ("/products/" + handle) : "#"));
    var variantId = egCompareGetVariantId(p);
    var productId = String(p && (p.product_id || p.id || "") || "");
    var hoverHtml = "";

    hoverHtml =
      '<div class="eg-compare-modal__hover">' +
        '<div class="eg-compare-modal__hover-actions">' +
          egCompareBuildThemeAddForm(p, available) +
          '<a href="' + productUrl + '" class="eg-compare-modal__hover-btn eg-compare-modal__hover-btn--view">View More</a>' +
        '</div>' +
      '</div>';

    var reorderHtml = "";

    if (totalItems > 2) {
      reorderHtml = '<div class="eg-compare-modal__reorder">';

      if (itemIndex > 0) {
        reorderHtml +=
          '<button type="button" class="eg-compare-modal__reorder-btn" data-eg-compare-move="-1" data-eg-compare-index="' + itemIndex + '">◀</button>';
      }

      if (itemIndex < totalItems - 1) {
        reorderHtml +=
          '<button type="button" class="eg-compare-modal__reorder-btn" data-eg-compare-move="1" data-eg-compare-index="' + itemIndex + '">▶</button>';
      }

      reorderHtml += '</div>';
    }

    var removeHtml = "";

    if (totalItems > 2) {
      removeHtml =
        '<button type="button" class="eg-compare-modal__remove-btn" data-eg-compare-remove-card="' + String(p && p.handle || "") + '" aria-label="Remove from compare">×</button>';
    }

    var matchHtml = "";
    if (!isBaseProduct && matchPct !== null && matchPct !== undefined) {
      var tone = egCompareGetMatchTone(matchPct);

      matchHtml =
        '<div class="eg-compare-match-card eg-compare-match-card--inline">' +
          '<div class="eg-compare-match-card__bar" style="border-color:' + tone.border + ';">' +
            '<span class="eg-compare-match-card__fill" style="width:' + Math.max(0, Math.min(100, matchPct || 0)) + '%; background:' + tone.fill + ';"></span>' +
            '<span class="eg-compare-match-card__text">' + String(matchPct || 0) + '% Match</span>' +
          '</div>' +
        '</div>';
    }

    var baseBadgeHtml = "";
    if (isBaseProduct) {
      baseBadgeHtml = '<div class="eg-compare-modal__primary-badge">Base Product</div>';
    }

    var legacyBadgeHtml = isLegacy ? egCompareBuildLegacyBadgeHtml() : "";
    var priceHtml = isLegacy
      ? '<div class="eg-compare-modal__product-price eg-compare-modal__product-price--placeholder" aria-hidden="true"></div>'
      : ('<div class="eg-compare-modal__product-price">' + price + '</div>');
    var stockHtml = isLegacy
      ? legacyBadgeHtml
      : ('<div class="eg-compare-modal__product-stock ' + (available ? 'is-instock' : 'is-oos') + '">' +
          (available ? 'In stock' : 'Out of stock') +
        '</div>');

    el.innerHTML =
      reorderHtml +
      removeHtml +
      '<div class="eg-compare-modal__product-media">' +
        (img ? '<img src="' + img + '" alt="">' : '') +
        hoverHtml +
      '</div>' +
      '<div class="eg-compare-modal__product-title">' + title + '</div>' +
      priceHtml +
      baseBadgeHtml +
      matchHtml +
      stockHtml;

    return el;
  }

  function egCompareRenderTable(root, products, typeKey, tableEl) {
    var cfg = egCompareGetConfigForContext(root, typeKey);
    var handle = egCompareGetCollectionHandle(root);
    var dynamicGroups = egCompareBuildGroupsFromFilterConfig(handle);

    if (!dynamicGroups.length && cfg && cfg.groups && cfg.groups.length) {
      dynamicGroups = cfg.groups;
    }

    var groups = dynamicGroups || [];

    if (!groups.length) {
      tableEl.innerHTML = "<div>No compare rows configured.</div>";
      return;
    }

    if (products.length === 2) {
      var twoUpScores = egCompareCalculateMatch(root, products, typeKey);
      var twoUpMatch = (twoUpScores && twoUpScores.length) ? twoUpScores[0] : 0;

      // IMPORTANT: break out of table wrapper styling
      tableEl.classList.add("is-two-up-active");

      tableEl.innerHTML = egCompareRenderTableTwoUp(root, typeKey, products, groups, twoUpMatch);
      return;
    }
    tableEl.classList.remove("is-two-up-active");
    tableEl.innerHTML = egCompareRenderTableMulti(root, typeKey, products, groups);
  }

    function egCompareParseNumericValue(val) {
    var s = String(val || "").replace(/,/g, "").trim();
    if (!s) return null;

    var m = s.match(/-?\d+(\.\d+)?/);
    if (!m) return null;

    var n = parseFloat(m[0]);
    return isNaN(n) ? null : n;
  }

  function egCompareExtractDeltaUnit() {
    var i;
    var s = "";

    for (i = 0; i < arguments.length; i++) {
      s = String(arguments[i] || "").trim();
      if (!s) continue;

      // Prefer trailing letter/symbol units like mm, cm, g, hrs, dB, m, cm²
      var m = s.match(/[a-zA-Z²%]+$/);
      if (m && m[0]) return m[0];
    }

    return "";
  }

  function egCompareFormatRoundedNumber(n) {
    var rounded;

    if (n === null || n === undefined || isNaN(n)) return "";

    rounded = Math.round(n * 100) / 100;

    // Avoid "-0"
    if (Math.abs(rounded) < 0.000001) rounded = 0;

    if (Math.round(rounded) === rounded) {
      return String(Math.round(rounded));
    }

    return String(rounded.toFixed(2)).replace(/\.?0+$/, "");
  }

  function egCompareFormatDelta(delta, refA, refB) {
    if (delta === null || delta === undefined || isNaN(delta) || Math.abs(delta) < 0.000001) return "";

    var absDelta = Math.abs(delta);
    var unit = egCompareExtractDeltaUnit(refA, refB);
    var text = egCompareFormatRoundedNumber(absDelta);

    return (delta > 0 ? "▲ +" : "▼ ") + text;
  }

  function egCompareGetMatchTone(matchPct) {
    var pct = Number(matchPct || 0);

    if (pct <= 25) {
      return {
        fill: "#d32f2f",
        border: "#d32f2f"
      };
    }

    if (pct <= 54) {
      return {
        fill: "#f57c00",
        border: "#f57c00"
      };
    }

    if (pct <= 79) {
      return {
        fill: "#fbc02d",
        border: "#fbc02d"
      };
    }

    return {
      fill: "#2e7d32",
      border: "#2e7d32"
    };
  }

  function egCompareGetDirectionRule(root, typeKey, rowKey) {
    var cfg = egCompareGetConfigForContext(root, typeKey);
    var rules = (cfg && cfg.directionRules) || {};
    return rules[rowKey] || "";
  }

  function egCompareGetTwoUpCenterRows(root, typeKey, groups, leftGroupMaps, rightGroupMaps) {
    var cfg = egCompareGetConfigForContext(root, typeKey);
    var centerCfg = (cfg && cfg.centerHighlights) || {};

    var preferredKeysArr = centerCfg.preferredKeys || [
      "firmness",
      "texture",
      "surface_texture",
      "glide",
      "surface_type",
      "thickness",
      "weight"
    ];

    var maxItems = centerCfg.maxItems || 2;

    var preferredKeys = {};
    for (var pk = 0; pk < preferredKeysArr.length; pk++) {
      preferredKeys[preferredKeysArr[pk]] = true;
    }

    var out = [];
    var used = {};

    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var rows = group.rows || [];
      var leftMap = leftGroupMaps[g] || {};
      var rightMap = rightGroupMaps[g] || {};

      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        if (!row || !row.key || !preferredKeys[row.key]) continue;

        var leftVal = leftMap[row.key] || "—";
        var rightVal = rightMap[row.key] || "—";
        var same = egCompareNormalize(leftVal) === egCompareNormalize(rightVal);

        if (same) continue;
        if (used[row.key]) continue;

        out.push({
          key: row.key,
          label: row.label || row.key,
          leftVal: leftVal,
          rightVal: rightVal
        });
        used[row.key] = true;

        if (out.length >= maxItems) return out;
      }
    }

    for (var g2 = 0; g2 < groups.length; g2++) {
      var group2 = groups[g2];
      var rows2 = group2.rows || [];
      var leftMap2 = leftGroupMaps[g2] || {};
      var rightMap2 = rightGroupMaps[g2] || {};

      for (var r2 = 0; r2 < rows2.length; r2++) {
        var row2 = rows2[r2];
        if (!row2 || !row2.key || used[row2.key]) continue;

        var leftVal2 = leftMap2[row2.key] || "—";
        var rightVal2 = rightMap2[row2.key] || "—";
        var same2 = egCompareNormalize(leftVal2) === egCompareNormalize(rightVal2);

        if (same2) continue;

        out.push({
          key: row2.key,
          label: row2.label || row2.key,
          leftVal: leftVal2,
          rightVal: rightVal2
        });
        used[row2.key] = true;

        if (out.length >= maxItems) return out;
      }
    }

    return out;
  }

  function egCompareBuildTwoUpCenterBlock(groups, leftGroupMaps, rightGroupMaps, matchPct) {
    var html = '<div class="eg-compare-two-up-center">';
    var tone = egCompareGetMatchTone(matchPct);

    html += '<div class="eg-compare-two-up-center__vs">VS</div>';

    html +=
      '<div class="eg-compare-two-up-center__match">' +
        '<div class="eg-compare-two-up-center__match-bar" style="border-color:' + tone.border + ';">' +
          '<span class="eg-compare-two-up-center__match-fill" style="width:' + Math.max(0, Math.min(100, matchPct || 0)) + '%; background:' + tone.fill + ';"></span>' +
          '<span class="eg-compare-two-up-center__match-text">' + String(matchPct || 0) + '% Match</span>' +
        '</div>' +
      '</div>';

    html += '</div>';
    return html;
  }

  function egCompareBuildTwoUpMidSpine(root, typeKey, groups, leftGroupMaps, rightGroupMaps) {
    var rows = egCompareGetTwoUpCenterRows(root, typeKey, groups, leftGroupMaps, rightGroupMaps);

    var html = '<div class="eg-compare-two-up-spine">';

    html += '<div class="eg-compare-two-up-spine__title">Key Differences</div>';

    html += '<div class="eg-compare-two-up-spine__highlights">';
    for (var i = 0; i < rows.length; i++) {
      html +=
        '<div class="eg-compare-two-up-spine__highlight">' +
          '<div class="eg-compare-two-up-spine__highlight-label">' + rows[i].label + '</div>' +
          '<div class="eg-compare-two-up-spine__highlight-values">' +
            '<span class="eg-compare-two-up-spine__highlight-left">' + rows[i].leftVal + '</span>' +
            '<span class="eg-compare-two-up-spine__highlight-right">' + rows[i].rightVal + '</span>' +
          '</div>' +
        '</div>';
    }
    html += '</div>';

    html +=
      '<label class="eg-compare-diff-toggle">' +
        '<input type="checkbox" class="eg-compare-diff-toggle__input">' +
        '<span class="eg-compare-diff-toggle__ui"></span>' +
        '<span class="eg-compare-diff-toggle__text">≠ Only</span>' +
      '</label>';

    html += '</div>';
    return html;
  }

  function egCompareBuildTwoUpSidePanels(groups, leftGroupMaps, rightGroupMaps, side) {
    var html = '<div class="eg-compare-two-up-side eg-compare-two-up-side--' + side + '">';

    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var rows = group.rows || [];
      var leftMap = leftGroupMaps[g] || {};
      var rightMap = rightGroupMaps[g] || {};

      if (!rows.length) continue;

      html += '<div class="eg-compare-two-up-panel">';
      html += '<div class="eg-compare-two-up-panel__title">' + (group.label || "") + '</div>';
      html += '<div class="eg-compare-two-up-panel__rows">';

      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        var leftVal = leftMap[row.key] || "—";
        var rightVal = rightMap[row.key] || "—";
        var val = side === "left" ? leftVal : rightVal;
        var same = egCompareNormalize(leftVal) === egCompareNormalize(rightVal);
        var rowClass = same ? 'is-match' : 'is-diff';

        html +=
          '<div class="eg-compare-two-up-panel__row ' + rowClass + '">' +
            '<div class="eg-compare-two-up-panel__label">' + (row.label || row.key) + '</div>' +
            '<div class="eg-compare-two-up-panel__value">' + val + '</div>' +
          '</div>';
      }

      html += '</div>';
      html += '</div>';
    }

    html += '</div>';
    return html;
  }

  function egCompareBuildTwoUpSidePanelsWithDiff(root, typeKey, groups, leftGroupMaps, rightGroupMaps) {
    var html = '<div class="eg-compare-two-up-side eg-compare-two-up-side--right">';

    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var rows = group.rows || [];
      var leftMap = leftGroupMaps[g] || {};
      var rightMap = rightGroupMaps[g] || {};

      if (!rows.length) continue;

      html += '<div class="eg-compare-two-up-panel">';
      html += '<div class="eg-compare-two-up-panel__title">' + (group.label || "") + '</div>';
      html += '<div class="eg-compare-two-up-panel__rows">';

      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        var leftVal = leftMap[row.key] || "—";
        var rightVal = rightMap[row.key] || "—";
        var same = egCompareNormalize(leftVal) === egCompareNormalize(rightVal);

        var leftNum = egCompareParseNumericValue(leftVal);
        var rightNum = egCompareParseNumericValue(rightVal);
        var delta = (leftNum !== null && rightNum !== null) ? (rightNum - leftNum) : null;
        var deltaText = (!same && delta !== null) ? egCompareFormatDelta(delta, rightVal, leftVal) : "";

        var rowClass = same ? 'is-match' : 'is-diff';
        var deltaClass = '';
        var directionRule = egCompareGetDirectionRule(root, typeKey, row.key);

        if (!same && delta !== null && directionRule) {
          if (directionRule === "higher") {
            if (delta > 0) {
              rowClass += ' is-better';
              deltaClass = ' is-better';
            } else if (delta < 0) {
              rowClass += ' is-worse';
              deltaClass = ' is-worse';
            }
          } else if (directionRule === "lower") {
            if (delta < 0) {
              rowClass += ' is-better';
              deltaClass = ' is-better';
            } else if (delta > 0) {
              rowClass += ' is-worse';
              deltaClass = ' is-worse';
            }
          }
        }

        html +=
          '<div class="eg-compare-two-up-panel__row ' + rowClass + '">' +
            '<div class="eg-compare-two-up-panel__label">' + (row.label || row.key) + '</div>' +
            '<div class="eg-compare-two-up-panel__valuewrap">' +
              (deltaText ? '<span class="eg-compare-two-up-panel__delta' + deltaClass + '">' + deltaText + '</span>' : '') +
              '<div class="eg-compare-two-up-panel__value">' + rightVal + '</div>' +
            '</div>' +
          '</div>';
      }

      html += '</div>';
      html += '</div>';
    }

    html += '</div>';
    return html;
  }

  function egCompareRenderTableTwoUp(root, typeKey, products, groups, matchPct) {
    var leftGroupMaps = [];
    var rightGroupMaps = [];

    for (var g = 0; g < groups.length; g++) {
      var rows = groups[g] && groups[g].rows ? groups[g].rows : [];
      leftGroupMaps.push(egCompareBuildProductFieldMap(products[0], rows));
      rightGroupMaps.push(egCompareBuildProductFieldMap(products[1], rows));
    }

    var html = '<div class="eg-compare-two-up-layout">';
    html += egCompareBuildTwoUpSidePanels(groups, leftGroupMaps, rightGroupMaps, "left");
    html += egCompareBuildTwoUpMidSpine(root, typeKey, groups, leftGroupMaps, rightGroupMaps);
    html += egCompareBuildTwoUpSidePanelsWithDiff(root, typeKey, groups, leftGroupMaps, rightGroupMaps);
    html += '</div>';

    return html;
  }

  function egCompareRenderTableMulti(root, typeKey, products, groups) {
    var html = "";

    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var rows = group.rows || [];

      if (!rows.length) continue;

      var maps = [];
      for (var i = 0; i < products.length; i++) {
        maps.push(egCompareBuildProductFieldMap(products[i], rows));
      }

      html += '<div class="eg-compare-group">';
      html += '<div class="eg-compare-group__title">' + (group.label || "") + '</div>';
      html += '<div class="eg-compare-table">';

      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        var label = row.label || row.key;
        var baseVal = maps[0][row.key] || "";
        var baseNum = egCompareParseNumericValue(baseVal);
        var directionRule = egCompareGetDirectionRule(root, typeKey, row.key);

        html += '<div class="eg-compare-row">';
        html += '<div class="eg-compare-cell eg-compare-cell--label">' + label + '</div>';

        for (var c = 0; c < maps.length; c++) {
          var val = maps[c][row.key] || "";
          var match = (egCompareNormalize(val) === egCompareNormalize(baseVal));
          var cellClass = match ? 'is-match' : 'is-diff';
          var deltaHtml = '';

          if (c > 0 && !match) {
            var valNum = egCompareParseNumericValue(val);
            var delta = (baseNum !== null && valNum !== null) ? (valNum - baseNum) : null;

            if (delta !== null) {
              var deltaClass = '';
              if (directionRule) {
                if (directionRule === "higher") {
                  deltaClass = delta > 0 ? ' is-better' : (delta < 0 ? ' is-worse' : '');
                } else if (directionRule === "lower") {
                  deltaClass = delta < 0 ? ' is-better' : (delta > 0 ? ' is-worse' : '');
                }
              }

              deltaHtml = '<span class="eg-compare-cell__delta' + deltaClass + '">' + egCompareFormatDelta(delta, val, baseVal) + '</span>';
            }
          }

          html +=
            '<div class="eg-compare-cell ' + cellClass + '">' +
              '<div class="eg-compare-cell__valuewrap">' +
                deltaHtml +
                '<span class="eg-compare-cell__value">' + (val || "—") + '</span>' +
              '</div>' +
            '</div>';
        }

        html += '</div>';
      }

      html += '</div>';
      html += '</div>';
    }

    return html || "<div>No compare rows configured.</div>";
  }

function egCompareCalculateMatch(root, products, typeKey) {
  root = root || egCompareGetRoot();

  var matchCfg = egCompareGetMatchConfigForContext(root, typeKey);
  var weightedFields = matchCfg.weightedFields || [];
  if (!weightedFields.length || products.length < 2) return null;

  var cfg = egCompareGetConfigForContext(root, typeKey);
  var handle = egCompareGetCollectionHandle(root);
  var dynamicGroups = egCompareBuildGroupsFromFilterConfig(handle);

  if (!dynamicGroups.length && cfg && cfg.groups && cfg.groups.length) {
    dynamicGroups = cfg.groups;
  }

  var rows = egCompareFlattenRowsFromGroups(dynamicGroups);
  rows = egCompareMergeMatchOnlyRows(rows, matchCfg);
  var rowMap = {};
  var i;
  var p;

  for (i = 0; i < rows.length; i++) {
    rowMap[rows[i].key] = rows[i];
  }

  var maps = [];
  for (p = 0; p < products.length; p++) {
    maps.push(egCompareBuildProductFieldMap(products[p], rows));
  }

  var base = maps[0];
  var scores = [];

  for (i = 1; i < maps.length; i++) {
    var compare = maps[i];
    var totalWeight = 0;
    var matchedWeight = 0;
    var excluded = false;
    var wf;
    var eq;
    var rawScore;
    var x;

    for (x = 0; x < (matchCfg.excludeIfAllMatch || []).length; x++) {
      var exAllKey = matchCfg.excludeIfAllMatch[x];
      if (!rowMap[exAllKey]) continue;
      eq = egCompareFieldEquals(base, compare, exAllKey);
      if (eq === true) {
        excluded = true;
        break;
      }
    }

    if (!excluded) {
      for (x = 0; x < (matchCfg.excludeIfAnyDiff || []).length; x++) {
        var exDiffKey = matchCfg.excludeIfAnyDiff[x];
        if (!rowMap[exDiffKey]) continue;
        eq = egCompareFieldEquals(base, compare, exDiffKey);
        if (eq === false) {
          excluded = true;
          break;
        }
      }
    }

    if (excluded) {
      scores.push(-1);
      continue;
    }

    for (x = 0; x < weightedFields.length; x++) {
      wf = weightedFields[x];
      if (!wf || !wf.key || !rowMap[wf.key]) continue;

      var weight = Number(wf.weight || 0);
      if (!(weight > 0)) continue;

      var a = egCompareNormalize(base[wf.key]);
      var b = egCompareNormalize(compare[wf.key]);

      if (!a && !b) continue;

      totalWeight += weight;
      if (a && b && a === b) matchedWeight += weight;
    }

    rawScore = totalWeight ? Math.round((matchedWeight / totalWeight) * 100) : 0;
    rawScore = egCompareApplyScoreAdjusters(rawScore, base, compare, matchCfg.scoreAdjusters || []);

    if (rawScore < 0) rawScore = 0;
    if (rawScore > 100) rawScore = 100;

    scores.push(rawScore);
  }

  return scores;
}

    function egCompareRenderTwoUpHero(root, typeKey, products, groups, matchPct) {
    var leftGroupMaps = [];
    var rightGroupMaps = [];

    for (var g = 0; g < groups.length; g++) {
      var rows = groups[g] && groups[g].rows ? groups[g].rows : [];
      leftGroupMaps.push(egCompareBuildProductFieldMap(products[0], rows));
      rightGroupMaps.push(egCompareBuildProductFieldMap(products[1], rows));
    }

    var leftTitle = String(products[0] && products[0].title || "");
    var rightTitle = String(products[1] && products[1].title || "");
    var leftImg = String(products[0] && products[0].image || "");
    var rightImg = String(products[1] && products[1].image || "");
    var leftLegacy = egCompareIsLegacyProduct(products[0]);
    var rightLegacy = egCompareIsLegacyProduct(products[1]);
    var leftPrice = leftLegacy ? "" : egCompareFormatPrice(products[0]);
    var rightPrice = rightLegacy ? "" : egCompareFormatPrice(products[1]);
    var leftStock = !!(products[0] && (products[0].variant_available || products[0].available));
    var rightStock = !!(products[1] && (products[1].variant_available || products[1].available));

    var html = '<div class="eg-compare-two-up-hero">';

    var leftHandle = String(products[0] && products[0].handle || "");
    var leftUrl = String((products[0] && products[0].url) || (leftHandle ? ("/products/" + leftHandle) : "#"));
    var leftVariantId = egCompareGetVariantId(products[0]);

    var rightHandle = String(products[1] && products[1].handle || "");
    var rightUrl = String((products[1] && products[1].url) || (rightHandle ? ("/products/" + rightHandle) : "#"));
    var rightVariantId = egCompareGetVariantId(products[1]);

    html += '<div class="eg-compare-two-up-hero__side eg-compare-two-up-hero__side--left">';
    html +=   '<div class="eg-compare-two-up-hero__media">';
    html +=     (leftImg ? '<img src="' + leftImg + '" alt="">' : '');
    html +=     '<div class="eg-compare-modal__hover">' +
                  '<div class="eg-compare-modal__hover-actions">' +
                    egCompareBuildThemeAddForm(products[0], leftStock) +
                    '<a href="' + leftUrl + '" class="eg-compare-modal__hover-btn eg-compare-modal__hover-btn--view">View More</a>' +
                  '</div>' +
                '</div>';
    html +=   '</div>';
    html +=   '<div class="eg-compare-two-up-hero__title">' + leftTitle + '</div>';
    if (!leftLegacy) {
      html += '<div class="eg-compare-two-up-hero__price">' + leftPrice + '</div>';
      html += '<div class="eg-compare-two-up-hero__stock ' + (leftStock ? 'is-instock' : 'is-oos') + '">' + (leftStock ? 'In stock' : 'Out of stock') + '</div>';
    } else {
      html += egCompareBuildLegacyBadgeHtml();
    }
    html += '</div>';

    html += egCompareBuildTwoUpCenterBlock(groups, leftGroupMaps, rightGroupMaps, matchPct);

    html += '<div class="eg-compare-two-up-hero__side eg-compare-two-up-hero__side--right">';
    html +=   '<div class="eg-compare-two-up-hero__media">';
    html +=     (rightImg ? '<img src="' + rightImg + '" alt="">' : '');
    html +=     '<div class="eg-compare-modal__hover">' +
                  '<div class="eg-compare-modal__hover-actions">' +
                    egCompareBuildThemeAddForm(products[1], rightStock) +
                    '<a href="' + rightUrl + '" class="eg-compare-modal__hover-btn eg-compare-modal__hover-btn--view">View More</a>' +
                  '</div>' +
                '</div>';
    html +=   '</div>';
    html +=   '<div class="eg-compare-two-up-hero__title">' + rightTitle + '</div>';
    if (!rightLegacy) {
      html += '<div class="eg-compare-two-up-hero__price">' + rightPrice + '</div>';
      html += '<div class="eg-compare-two-up-hero__stock ' + (rightStock ? 'is-instock' : 'is-oos') + '">' + (rightStock ? 'In stock' : 'Out of stock') + '</div>';
    } else {
      html += egCompareBuildLegacyBadgeHtml();
    }
    html += '</div>';

    html += '</div>';
    return html;
  }

  function egCompareOpenModal(root) {
    root = root || egCompareGetRoot();
    if (!root) return;

    var handle = egCompareGetCollectionHandle(root);
    var products = egCompareGetProducts(handle);

    if (products.length < 2) return;

    var typeKey = egCompareGetTypeKeyFromProducts(products);
    egCompareTrackOpen(root, products, typeKey);
    var modal = egCompareEnsureModal();
    var titleEl = modal.querySelector("[data-eg-compare-modal-title]");
    var subtitleEl = modal.querySelector("[data-eg-compare-modal-subtitle]");
    modal.classList.remove("is-two-up", "is-multi");
    modal.classList.add(products.length === 2 ? "is-two-up" : "is-multi");
    modal.setAttribute("data-eg-compare-count", String(products.length));
    var productsEl = modal.querySelector("[data-eg-compare-modal-products]");
    var metaEl = modal.querySelector("[data-eg-compare-modal-meta]");
    var statusEl = modal.querySelector("[data-eg-compare-modal-status]");
    var tableEl = modal.querySelector("[data-eg-compare-modal-table]");

    var cfg = egCompareGetConfigForContext(root, typeKey);
    var matchCfg = egCompareGetMatchConfigForContext(root, typeKey);

    if (titleEl) {
      titleEl.textContent = cfg.title || "Compare Products";
    }

    if (subtitleEl) {
      subtitleEl.textContent = products.length + " products selected";
    }

   egCompareRenderModalSearch(root, modal, products, typeKey);

    if (productsEl) {
      productsEl.innerHTML = "";

      if (products.length === 2 && typeKey) {
        var heroCfg = egCompareGetConfigForContext(root, typeKey);
        var heroHandle = egCompareGetCollectionHandle(root);
        var heroGroups = egCompareBuildGroupsFromFilterConfig(heroHandle);

        if (!heroGroups.length && heroCfg && heroCfg.groups && heroCfg.groups.length) {
          heroGroups = heroCfg.groups;
        }

        var heroScores = egCompareCalculateMatch(root, products, typeKey);
        var heroMatch = (heroScores && heroScores.length) ? heroScores[0] : 0;

        productsEl.innerHTML = egCompareRenderTwoUpHero(root, typeKey, products, heroGroups, heroMatch);
      } else {
        var multiScores = typeKey ? egCompareCalculateMatch(root, products, typeKey) : null;

        for (var i = 0; i < products.length; i++) {
          var matchPct = null;
          var isBaseProduct = (i === 0);

          if (!isBaseProduct && multiScores && multiScores.length >= i) {
            matchPct = multiScores[i - 1];
          }

          productsEl.appendChild(
            egCompareBuildModalProductCard(
              products[i],
              matchPct,
              isBaseProduct,
              i,
              products.length
            )
          );
        }
      }
    }

    if (statusEl) {
      if (!typeKey) {
        statusEl.innerHTML = "Compare only works when all selected products are from the same category.";
        statusEl.className = "eg-compare-modal__status is-error";
      } else {
        statusEl.innerHTML = "";
        statusEl.className = "eg-compare-modal__status is-ready";
      }
    }

    if (tableEl) {
      if (typeKey) {
        egCompareRenderTable(root, products, typeKey, tableEl);

        if (metaEl) {
          metaEl.innerHTML = "";
        }

        var scores = egCompareCalculateMatch(root, products, typeKey);
        if (metaEl && scores && scores.length) {
          if (products.length === 2) {
            metaEl.innerHTML = "";
          } else {
            metaEl.innerHTML = "";
          }
        }
      } else {
        tableEl.innerHTML = "";
        if (metaEl) metaEl.innerHTML = "";
      }
    }

    var diffToggle = modal.querySelector(".eg-compare-diff-toggle__input");
    if (diffToggle) {
      diffToggle.checked = !!modal.__egDiffOnly;
      modal.classList.toggle("eg-compare--diff-only", !!modal.__egDiffOnly);

      diffToggle.addEventListener("change", function () {
        modal.__egDiffOnly = !!diffToggle.checked;
        modal.classList.toggle("eg-compare--diff-only", !!modal.__egDiffOnly);
      });
    }

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("eg-compare-modal-open");
    document.body.classList.add("eg-compare-modal-open");
  }

  function egCompareRenderTray(root) {
    root = root || egCompareGetRoot();
    if (!root) return;

    var handle = egCompareGetCollectionHandle(root);
    if (!handle) return;

    var tray = egCompareEnsureTray(root);
    if (!tray) return;

    var itemsHost = tray.querySelector("[data-eg-compare-items]");
    var countEl = tray.querySelector("[data-eg-compare-count]");
    var openBtn = tray.querySelector("[data-eg-compare-open]");

    var selected = egCompareGetSelectedHandles(handle);
    var count = selected.length;
    var max = egCompareGetMaxItems(root);

    tray.classList.toggle("is-active", count > 0);

    if (countEl) {
      countEl.textContent = count + " of " + max + " selected";
    }

    if (openBtn) {
    openBtn.disabled = count < 2;
    openBtn.textContent = count >= 2
        ? "Compare (" + count + ")"
        : "Compare";
    }

    if (itemsHost) {
      itemsHost.innerHTML = "";
      for (var i = 0; i < selected.length; i++) {
        itemsHost.appendChild(egCompareBuildChip(handle, selected[i]));
      }
    }

    if (typeof egCompareSyncCardUi === "function") {
      egCompareSyncCardUi(root);
    }
  }

  function egCompareBindTray(root) {
    root = root || egCompareGetRoot();
    if (!root || root.__egCompareTrayBound) return;
    root.__egCompareTrayBound = true;

    document.addEventListener("click", function (e) {
      var tray = egCompareGetTrayEl(root);
      if (!tray) return;

      var removeBtn = e.target && e.target.closest ? e.target.closest("[data-eg-compare-remove]") : null;
      if (removeBtn && tray.contains(removeBtn)) {
        e.preventDefault();
        egCompareRemove(egCompareGetCollectionHandle(root), removeBtn.getAttribute("data-eg-compare-remove") || "");
        egCompareRenderTray(root);
        return;
      }

      var clearBtn = e.target && e.target.closest ? e.target.closest("[data-eg-compare-clear]") : null;
      if (clearBtn && tray.contains(clearBtn)) {
        e.preventDefault();
        egCompareClear(egCompareGetCollectionHandle(root));
        egCompareRenderTray(root);
        return;
      }

      var openBtn = e.target && e.target.closest ? e.target.closest("[data-eg-compare-open]") : null;
      if (openBtn && tray.contains(openBtn)) {
        e.preventDefault();
        if (!openBtn.disabled) {
          egCompareOpenModal(root);
        }
        return;
      }
    }, false);
  }

    function egCompareBindModalUi(root) {
    root = root || egCompareGetRoot();
    if (!root || root.__egCompareModalUiBound) return;
    root.__egCompareModalUiBound = true;

    document.addEventListener("click", function (e) {
      var modal = egCompareGetModalEl();
      if (!modal || !modal.classList.contains("is-open")) return;

      var addFromSearchBtn = e.target && e.target.closest ? e.target.closest("[data-eg-compare-modal-add]") : null;
      if (addFromSearchBtn && modal.contains(addFromSearchBtn)) {
        e.preventDefault();

        var addHandle = addFromSearchBtn.getAttribute("data-eg-compare-modal-add") || "";
        var collectionHandle = egCompareGetCollectionHandle(root);

        if (egCompareAddHandle(collectionHandle, addHandle)) {
          egCompareRenderTray(root);
          egCompareClearModalSearch(modal);
          egCompareOpenModal(root);
        }

        return;
      }

      var removeCardBtn = e.target && e.target.closest ? e.target.closest("[data-eg-compare-remove-card]") : null;
      if (removeCardBtn && modal.contains(removeCardBtn)) {
        e.preventDefault();

        var removeHandle = removeCardBtn.getAttribute("data-eg-compare-remove-card") || "";
        var collectionHandle2 = egCompareGetCollectionHandle(root);

        egCompareRemove(collectionHandle2, removeHandle);
        egCompareRenderTray(root);

        var remaining = egCompareGetProducts(collectionHandle2);
        if (remaining.length >= 2) {
          egCompareOpenModal(root);
        } else {
          egCompareCloseModal();
        }
        return;
      }

      var moveBtn = e.target && e.target.closest ? e.target.closest("[data-eg-compare-move]") : null;
      if (moveBtn && modal.contains(moveBtn)) {
        e.preventDefault();

        if (moveBtn.disabled) return;

        var delta = parseInt(moveBtn.getAttribute("data-eg-compare-move") || "0", 10);
        var index = parseInt(moveBtn.getAttribute("data-eg-compare-index") || "-1", 10);
        var handle = egCompareGetCollectionHandle(root);

        if (isFinite(delta) && isFinite(index) && handle) {
          egCompareMoveSelected(handle, index, index + delta);
          egCompareRenderTray(root);
          egCompareOpenModal(root);
        }
        return;
      }

      var closeBtn = e.target && e.target.closest ? e.target.closest("[data-eg-compare-close]") : null;
      if (closeBtn && modal.contains(closeBtn)) {
        e.preventDefault();
        egCompareClearModalSearch(modal);
        egCompareCloseModal();
        return;
      }
    }, false);

    document.addEventListener("input", function (e) {
      var modal = egCompareGetModalEl();
      if (!modal || !modal.classList.contains("is-open")) return;

      var input = e.target && e.target.closest ? e.target.closest("[data-eg-compare-modal-search-input]") : null;
      if (!input || !modal.contains(input)) return;

      var handle = egCompareGetCollectionHandle(root);
      var products = egCompareGetProducts(handle);
      var typeKey = egCompareGetTypeKeyFromProducts(products);

      egCompareSetModalSearchQuery(modal, input.value || "");
      egCompareRenderModalSearch(root, modal, products, typeKey);
    });

    document.addEventListener("click", function (e) {
      var modal = egCompareGetModalEl();
      if (!modal || !modal.classList.contains("is-open")) return;

      var searchArea = modal.querySelector("[data-eg-compare-modal-searcharea]");
      if (!searchArea) return;

      if (searchArea.contains(e.target)) return;

      var dropdown = modal.querySelector("[data-eg-compare-modal-search-dropdown]");
      if (dropdown) {
        dropdown.innerHTML = "";
        dropdown.style.display = "none";
      }
    });

  }

function egCompareEnsureOverlayActionRows() {
  var compareBtns = document.querySelectorAll("[data-eg-compare-toggle]");
  var i;

  for (i = 0; i < compareBtns.length; i++) {
    var compareBtn = compareBtns[i];
    if (!compareBtn) continue;

    var currentParent = compareBtn.parentNode;
    if (!currentParent) continue;

    var host = currentParent;
    if (host.classList && host.classList.contains("eg-compare-card-actions-row")) {
      host = host.parentNode;
    }
    if (!host) continue;

    var similarBtn = host.querySelector("[data-eg-compare-find-similar]");
    if (!similarBtn) continue;

    var row = host.querySelector(":scope > .eg-compare-card-actions-row");
    if (!row) {
      row = document.createElement("div");
      row.className = "eg-compare-card-actions-row";
      host.appendChild(row);
    }

    if (compareBtn.parentNode !== row) row.appendChild(compareBtn);
    if (similarBtn.parentNode !== row) row.appendChild(similarBtn);
  }
}

function egCompareSyncCardUi(root) {
  root = root || egCompareGetRoot();
  if (!root) return;

  var handle = egCompareGetCollectionHandle(root);
  if (!handle) return;

  egCompareEnsureFindSimilarButtons(root);
  egCompareEnsureOverlayActionRows();

  var selected = egCompareGetSelectedHandles(handle);
  var max = egCompareGetMaxItems();
  var isMax = selected.length >= max;

  var nodes = document.querySelectorAll("[data-eg-compare-toggle]");

  for (var i = 0; i < nodes.length; i++) {
    var btn = nodes[i];
    var ph = String(btn.getAttribute("data-eg-compare-handle") || "").trim();
    var on = selected.indexOf(ph) !== -1;

    btn.classList.toggle("is-selected", on);
    btn.setAttribute("aria-pressed", on ? "true" : "false");

    var txt = btn.querySelector("[data-eg-compare-toggle-text]");
    if (txt) txt.textContent = on ? "Selected" : "Compare";

    // Disable if max reached and not already selected
    if (isMax && !on) {
      btn.disabled = true;
      btn.classList.add("is-disabled");
    } else {
      btn.disabled = false;
      btn.classList.remove("is-disabled");
    }
  }
}

  function egCompareBindCardToggles(root) {
    root = root || egCompareGetRoot();
    if (!root || root.__egCompareCardToggleBound) return;
    root.__egCompareCardToggleBound = true;

    document.addEventListener("click", function (e) {
      var similarBtn = e.target && e.target.closest ? e.target.closest("[data-eg-compare-find-similar]") : null;
      if (similarBtn) {
        e.preventDefault();

        var similarHandle = similarBtn.getAttribute("data-eg-compare-find-similar") || "";
        egCompareOpenWithSimilar(root, similarHandle);
        return;
      }

      var btn = e.target && e.target.closest ? e.target.closest("[data-eg-compare-toggle]") : null;
      if (!btn) return;

      e.preventDefault();

      var collectionHandle = egCompareGetCollectionHandle(root);
      var productHandle = btn.getAttribute("data-eg-compare-handle") || "";

      var out = egCompareToggle(collectionHandle, productHandle);

      if (!out.ok && out.reason === "max") {
        window.alert("You can compare up to " + egCompareGetMaxItems() + " products.");
        return;
      }

      egCompareRenderTray(root);
    }, false);
  }

  function egCompareInit(root) {
    root = root || egCompareGetRoot();
    if (!root || root.__egCompareInitDone) return false;
    root.__egCompareInitDone = true;

    egCompareEnsureBucket(egCompareGetCollectionHandle(root));
    egCompareEnsureTray(root);
    egCompareBindTray(root);
    egCompareBindModalUi(root);
    egCompareBindModalCartProxy();
    egCompareBindCardToggles(root);
    egCompareRenderTray(root);

    if (!window.__egCompareEscBound) {
      window.__egCompareEscBound = true;
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          egCompareCloseModal();
        }
      }, false);
    }

    return true;
  }

  window.egCompareInit = egCompareInit;
  window.egCompareRenderTray = egCompareRenderTray;
  window.egCompareSyncCardUi = egCompareSyncCardUi;
  window.egCompareGetSelectedHandles = egCompareGetSelectedHandles;
  window.egCompareIsSelected = egCompareIsSelected;
  window.egCompareGetCollectionHandle = egCompareGetCollectionHandle;
  window.egCompareGetMaxItems = egCompareGetMaxItems;
})();